import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import frTranslation from '../i18n/locales/fr/translation.json'

void i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: frTranslation },
  },
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
  returnNull: false,
})

export default i18n
